// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-width: 200px;
  --brand-primary: #0860D3;
  --brand-primary-hover: #208DE9;
  --brand-secondary: #78C2F8;
  --brand-accent: #A2CDF0;
  --brand-info: #5FA4E7;
  --brand-dark: #1555AB;
  --brand-navy: #0A2360;
  --text-primary: #020617;
  --text-secondary: #9B9FA2;
  --bg-page: #F2F7FB;
  --surface: #FFFFFF;
  --state-success: #16a34a;
  --state-success-hover: #22c55e;
  --state-danger: #dc3545;
  --state-danger-hover: #ef4444;
  --divider: rgba(160, 198, 232, 0.35);
}

body.theme-light {
  --bg-page: #F2F7FB;
  --surface: #FFFFFF;
  --text-primary: #020617;
  --text-secondary: #9B9FA2;
  --brand-primary: #0860D3;
  --brand-secondary: #78C2F8;
  --brand-info: #5FA4E7;
  --state-success: #16a34a;
  --state-success-hover: #22c55e;
  --state-danger: #dc3545;
  --state-danger-hover: #ef4444;
  --divider: rgba(160, 198, 232, 0.35);
}

body.theme-dark {
  --bg-page: #020617;
  --surface: #07101F;
  --text-primary: #F8FAFC;
  --text-secondary: #94A3B8;
  --brand-primary: #0860d3;
  --brand-secondary: #8B5CF6;
  --brand-info: #7DD3FC;
  --state-success: #22c55e;
  --state-success-hover: #4ade80;
  --state-danger: #ef4444;
  --state-danger-hover: #f87171;
  --divider: rgba(148, 163, 184, 0.25);
}

body {
  margin: 0;
  font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 12px !important;
  background: var(--bg-page) !important;
  color: var(--text-primary) !important;
}


.ag-theme-quartz .ag-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background-color: transparent !important;
}

.ag-theme-quartz .ag-header-cell-label {
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
}

.fleet-grid-header .ag-header-cell-label {
  justify-content: center;
  text-align: center;
}

.ag-theme-quartz .ag-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

body.theme-dark .ag-theme-quartz .ag-header {
  background-color: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
}

body.theme-dark .ag-theme-quartz .ag-header-cell-label {
  color: #94A3B8 !important;
}

body.theme-dark .ag-theme-quartz .ag-cell,
body.theme-dark .ag-theme-quartz .ag-row {
  color: #E5E7EB !important;
}

body.theme-dark .ag-theme-quartz .ag-row {
  border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;
}

body.theme-dark .ag-theme-quartz .ag-row-hover {
  background-color: rgba(255, 255, 255, 0.03) !important;
}

body.theme-dark .ag-theme-quartz .ag-row-selected {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

body.theme-dark .ag-theme-quartz .ag-header-cell,
body.theme-dark .ag-theme-quartz .ag-header-cell-text,
body.theme-dark .ag-theme-quartz .ag-header-viewport {
  color: #94A3B8 !important;
}

body.theme-dark .MuiInputLabel-root,
body.theme-dark .MuiFormLabel-root,
body.theme-dark .MuiInputBase-input,
body.theme-dark .MuiOutlinedInput-input,
body.theme-dark .MuiInputBase-inputSizeSmall,
body.theme-dark .MuiSelect-select,
body.theme-dark .MuiInput-input {
  color: #E5E7EB !important;
}

body.theme-dark .MuiInputLabel-root.Mui-focused,
body.theme-dark .MuiFormLabel-root.Mui-focused {
  color: #0860d3 !important;
}

.scroll {
  top: 0px;
  left: auto;
  color: rgb(123, 128, 154) !important;
  right: 0px !important;
  width: calc(100% - var(--sidebar-width)) !important;
  display: grid !important;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  z-index: 1100;
  position: relative;
  box-shadow: none !important;
  box-sizing: border-box !important;
  min-height: 4.6875rem;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important;
  align-items: center;
  flex-shrink: 0;
  margin-left: var(--sidebar-width);
  border-radius: 0.75rem;
  flex-direction: column !important;
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
  background-color: transparent !important;
}
.scroll::after {
  top: 0px !important;
  left: auto !important;
  color: rgb(52, 71, 103) !important;
  right: 0px !important;
  display: grid !important;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  z-index: 1100;
  position: fixed;
  box-shadow: rgb(255 255 255 / 90%) 0rem 0rem 0.0625rem 0.0625rem inset,
    rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem !important;
  box-sizing: border-box !important;
  margin-top: 10px;
  min-height: 4.6875rem !important;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  align-items: center;
  flex-shrink: 0;
  margin-right: 6px;
  border-radius: 0.75rem;
  flex-direction: column !important;
  -webkit-backdrop-filter: saturate(200%) blur(1.875rem) !important;
          backdrop-filter: saturate(200%) blur(1.875rem) !important;
  background-color: transparent !important;
}

.searchInput {
  background-color: rgba(5,85,170,0.5) !important;
  color: white;
  margin-right: 0px !important;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(56,189,248,0.3) !important;
  border-radius: 8px;
}

.fxt-template-layout21 {
  min-height: 100vh;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #020617;
  color: #f8fafc;
  padding: 15px;
}

/* Removed hardcoded black overrides for MuiTabs as they are handled in theme-context */

/* .fxt-template-animation {
  position: relative;
  z-index: 1;
  width: 100%;
  opacity: 0;
  overflow: hidden;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.fxt-template-layout21 #particles-js {
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  opacity: 0.5;
} */

.css-m3lf6h-MuiButtonBase-root-MuiListItemButton-root.Mui-focusVisible {
  background-color: #0555aa !important;
}

/* Define keyframes */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}

.super-app-theme--header {
  background-color: var(--brand-primary);
  color: white;
}

.MuiDataGrid-filler {
  background-color: var(--brand-primary);
}

.css-tgsonj {
  background-color: white !important;
}

.evenClassRow {
  background-color: rgba(8, 96, 211, 0.08);
  color: var(--text-primary);
}
.oddClassRow {
  background-color: rgba(8, 96, 211, 0.03);
}
/* .MuiDataGrid-footerContainer{
  background-color: rgb(156, 191, 46);
}
.MuiTablePagination-toolbar{
  color: white !important;
}
.MuiTablePagination-selectIcon,.MuiIconButton-sizeMedium{
  color: white !important;
} */
.MuiDataGrid-cell:focus {
  outline: solid #fff;
}
/* .MuiDataGrid-selectedRowCount{
  color: white;
} */

.MuiDataGrid-virtualScrollerContent .MuiDataGrid-row.Mui-selected {
  background-color: var(--brand-primary) !important;
  color: white !important;
}
.MuiDataGrid-virtualScrollerContent .MuiDataGrid-row:hover {
  background-color: rgba(8, 96, 211, 0.12) !important;
}
.MuiDataGrid-columnHeader:focus,
.MuiDataGrid-cell:focus {
  outline: none !important;
}
.MuiDataGrid-scrollbarFiller {
  display: none;
}
.MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-menuIconButton {
  color: white !important;
}
.MuiDataGrid-columnHeaderTitleContainer {
  background: var(--brand-primary) !important;
  font-size: 13px !important;
}
.dataGridContant {
  font-size: 12px !important;
}
.css-1essi2g-MuiDataGrid-columnHeaderRow {
  background-color: var(--brand-primary) !important;
  color: white !important;
}

/* Truck Loader */

body {
  padding: 0px;
  margin: 0px;
  background-color: transparent;
}

.loader-wrapper {
  position: fixed;
  z-index: 1090;
  height: 100vh;
  width: 100vw;
  background-color: rgba(13, 27, 62, 0.5) !important;
}

.loader-box {
  position: absolute;
  top: 30%;
  left: 40%;
  height: 200px;
  width: 200px;
}

.dot-spinner {
  --uib-size: 2.8rem;
  --uib-speed: 0.9s;
  --uib-color: #183153;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: var(--uib-size);
  width: var(--uib-size);
}

.dot-spinner__dot {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
}

.dot-spinner__dot::before {
  content: "";
  height: 20%;
  width: 20%;
  border-radius: 50%;
  background-color: var(--uib-color);
  transform: scale(0);
  opacity: 0.5;
  animation: pulse0112 calc(var(--uib-speed) * 1.111) ease-in-out infinite;
  box-shadow: 0 0 20px rgba(18, 31, 53, 0.3);
}

.dot-spinner__dot:nth-child(2) {
  transform: rotate(45deg);
}

.dot-spinner__dot:nth-child(2)::before {
  animation-delay: calc(var(--uib-speed) * -0.875);
}

.dot-spinner__dot:nth-child(3) {
  transform: rotate(90deg);
}

.dot-spinner__dot:nth-child(3)::before {
  animation-delay: calc(var(--uib-speed) * -0.75);
}

.dot-spinner__dot:nth-child(4) {
  transform: rotate(135deg);
}

.dot-spinner__dot:nth-child(4)::before {
  animation-delay: calc(var(--uib-speed) * -0.625);
}

.dot-spinner__dot:nth-child(5) {
  transform: rotate(180deg);
}

.dot-spinner__dot:nth-child(5)::before {
  animation-delay: calc(var(--uib-speed) * -0.5);
}

.dot-spinner__dot:nth-child(6) {
  transform: rotate(225deg);
}

.dot-spinner__dot:nth-child(6)::before {
  animation-delay: calc(var(--uib-speed) * -0.375);
}

.dot-spinner__dot:nth-child(7) {
  transform: rotate(270deg);
}

.dot-spinner__dot:nth-child(7)::before {
  animation-delay: calc(var(--uib-speed) * -0.25);
}

.dot-spinner__dot:nth-child(8) {
  transform: rotate(315deg);
}

.dot-spinner__dot:nth-child(8)::before {
  animation-delay: calc(var(--uib-speed) * -0.125);
}

@keyframes pulse0112 {
  0%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }

  50% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fade {
  30% {
    opacity: 0.3;
    left: 7px;
  }
  50% {
    opacity: 0.5;
    left: 6px;
  }

  70% {
    opacity: 0.1;
    left: 4px;
  }

  90% {
    opacity: 0.4;
    left: 2px;
  }
}

@keyframes bg {
  from {
    background-position-x: 0px;
  }
  to {
    background-position-x: -400px;
  }
}

@keyframes updown {
  50% {
    transform: translateY(-20%);
  }

  70% {
    transform: translateY(-10%);
  }
}

@keyframes updown-half {
  50% {
    transform: translateY(-10%);
  }

  70% {
    transform: translateY(-5%);
  }
}

.Mui-checked {
  color: white !important;
}

.css-19kzrtu {
  padding: 0px !important;
}
span {
  font-size: 12px !important;
}
.MuiDataGrid-sortIcon,
.MuiDataGrid-menuIconButton {
  color: #ffff !important;
  font-weight: 600;
}

::-webkit-scrollbar {
  width: 7px;
  height: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0555aa;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.MuiButtonBase-root {
  font-size: 12px !important;
}
.MuiDataGrid-cell {
  font-size: 12px !important;
}

.MuiTablePagination-menuItem {
  top: calc(100% - 180px) !important;
}
#star {
  animation: rotateStar 1s linear infinite;
  transform-origin: 325px 305px; /* Center of the circle */
}

@keyframes rotateStar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.ag-paging-panel {
  background: rgba(248, 250, 252, 0.95) !important;
  color: #0f172a !important;
  border-top: 1px solid rgba(148, 163, 184, 0.35) !important;
}
.ag-paging-panel .ag-input-field-input,
.ag-paging-panel .ag-select,
.ag-paging-panel .ag-paging-button {
  background: #ffffff !important;
  color: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
.ag-paging-panel .ag-paging-button:hover {
  background: rgba(29, 78, 216, 0.08) !important;
}
.ag-wrapper {
  color: #0f172a !important;
}
.ag-header {
  border-bottom: 1px solid rgba(148, 163, 184, 0.35) !important;
}
.ag-header-row-column {
  background: transparent !important;
  color: #1D4ED8 !important;
  font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;
}
.ag-icon {
  color: #1D4ED8 !important;
}
.ag-row {
  background-color: transparent !important;
  color: #020617 !important;
  font-size: 12px !important;
  font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;
}
.ag-row-selected {
  background: rgba(59, 130, 246, 0.12) !important;
  color: #0f172a !important;
}
.ag-row-hover {
  background: rgba(191, 219, 254, 0.6) !important;
  color: #0f172a !important;
  opacity: 1 !important;
}
.highlight-red {
  color: red;
}
body.theme-dark .ag-paging-panel {
  background: rgba(15, 23, 42, 0.95) !important;
  color: #E5E7EB !important;
  border-top: 1px solid rgba(100, 116, 139, 0.25) !important;
}
body.theme-dark .ag-paging-panel .ag-input-field-input,
body.theme-dark .ag-paging-panel .ag-select,
body.theme-dark .ag-paging-panel .ag-paging-button {
  background: #111827 !important;
  color: #E5E7EB !important;
  border-color: rgba(100, 116, 139, 0.4) !important;
}
body.theme-dark .ag-paging-panel .ag-paging-button:hover {
  background: rgba(59, 130, 246, 0.12) !important;
}
body.theme-dark .ag-wrapper {
  color: #E5E7EB !important;
}
body.theme-dark .ag-header {
  border-bottom: 1px solid rgba(100, 116, 139, 0.35) !important;
}
body.theme-dark .ag-header-row-column {
  background: transparent !important;
  color: #93C5FD !important;
}
body.theme-dark .ag-icon {
  color: #93C5FD !important;
}
body.theme-dark .ag-row {
  background-color: transparent !important;
  color: #E5E7EB !important;
}
body.theme-dark .ag-row-selected {
  background: rgba(59, 130, 246, 0.18) !important;
  color: #E5E7EB !important;
}
body.theme-dark .ag-row-hover {
  background: rgba(59, 130, 246, 0.18) !important;
  color: #E5E7EB !important;
  opacity: 1 !important;
}
.ag-row-hover .highlight-red {
  background: red !important;
  color: white !important;
  opacity: 1 !important;
}

.ag-row-selected .muiSeletc,
.ag-row-hover .muiSeletc,
.ag-row-selected .muiSeletc svg,
.ag-row-hover .muiSeletc svg {
  color: #0f172a !important;
  opacity: 1 !important;
}
.SelectedModelClass .MuiSelect-select,
.Mui-focused {
  background-color: transparent !important;
  border: none;
}
.ag-row-selected .SelectedModelClass .MuiInputBase-root::after {
  border-bottom: 1px solid #1D4ED8 !important;
}
.ag-row-selected .SelectedModelClass .MuiInputBase-root::before {
  border-bottom: 1px solid #1D4ED8 !important;
}
.SelectedModelClass .MuiInputBase-root::after {
  border-bottom: 1px solid rgba(29, 78, 216, 0.4) !important;
}
.SelectedModelClass .MuiInputBase-root::before {
  border-bottom: 1px solid rgba(255, 255, 255, 0.407) !important;
}
.css-q46f9q-MuiInputBase-root-MuiInput-root {
  font-size: 12px !important;
}
.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10px !important;
  font-size: 12px !important;
}
.ag-checkbox-input-wrapper.ag-checked::after {
  color: #0860d3 !important;
}

.ag-theme-quartz {
  --ag-active-color: #1D4ED8 !important;
  --ag-background-color: #FFFFFF !important;
  --ag-header-background-color: #FFFFFF !important;
  --ag-row-hover-color: rgba(191, 219, 254, 0.55) !important;
  --ag-selected-row-background-color: rgba(59, 130, 246, 0.14) !important;
  --ag-odd-row-background-color: #F8FAFC !important;
  --ag-foreground-color: #0F172A !important;
  --ag-header-foreground-color: #1D4ED8 !important;
  --ag-border-color: rgba(148, 163, 184, 0.3) !important;
  --ag-row-border-color: rgba(148, 163, 184, 0.18) !important;
  --ag-secondary-foreground-color: #64748B !important;
  --ag-input-focus-border-color: #1D4ED8 !important;
  --ag-font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;
}
body.theme-dark .ag-theme-quartz {
  --ag-active-color: #60A5FA !important;
  --ag-background-color: #111827 !important;
  --ag-header-background-color: #1F2937 !important;
  --ag-row-hover-color: rgba(59, 130, 246, 0.18) !important;
  --ag-selected-row-background-color: rgba(59, 130, 246, 0.18) !important;
  --ag-odd-row-background-color: rgba(255, 255, 255, 0.04) !important;
  --ag-foreground-color: #E5E7EB !important;
  --ag-header-foreground-color: #93C5FD !important;
  --ag-border-color: rgba(148, 163, 184, 0.15) !important;
  --ag-row-border-color: rgba(148, 163, 184, 0.08) !important;
  --ag-secondary-foreground-color: #94A3B8 !important;
  --ag-input-focus-border-color: #60A5FA !important;
}
.MuiDialog-paperScrollPaper,
.MuiDialog-paperScrollPaper form {
  width: 100% !important;
}

.DrawerName {
  bottom: 56px !important;
  top: 80px !important;
}

/* ─── Adaptive glassmorphism for all Drawer popups ─── */
.MuiDrawer-paperAnchorBottom {
  bottom: 56px !important;
  top: 80px !important;
  background: var(--surface) !important;
  body.theme-dark .ag-theme-quartz .ag-root-wrapper,
  body.theme-dark .ag-theme-quartz .ag-header {
    background: var(--surface) !important;
  }
  -webkit-backdrop-filter: blur(40px) !important;
          backdrop-filter: blur(40px) !important;
  border-top: 1px solid var(--divider) !important;
  color: var(--text-primary) !important;
}

/* Fix all labels, text and inputs inside drawers */
.MuiDrawer-paperAnchorBottom label,
.MuiDrawer-paperAnchorBottom .MuiInputLabel-root,
.MuiDrawer-paperAnchorBottom .MuiFormLabel-root {
  color: var(--text-secondary);
}
.MuiDrawer-paperAnchorBottom .MuiInputLabel-root.Mui-focused {
  color: var(--brand-primary) !important;
}
.MuiDrawer-paperAnchorBottom .MuiSelect-select,
.MuiDrawer-paperAnchorBottom .MuiInputBase-input,
.MuiDrawer-paperAnchorBottom .MuiInput-input {
  color: var(--text-primary) !important;
}
.MuiDrawer-paperAnchorBottom .MuiInput-underline::before {
  border-bottom-color: var(--divider) !important;
}
.MuiDrawer-paperAnchorBottom .MuiInput-underline::after {
  border-bottom-color: var(--brand-primary) !important;
}
.MuiDrawer-paperAnchorBottom .MuiSvgIcon-root {
  color: var(--text-secondary) !important;
}
.MuiDrawer-paperAnchorBottom .MuiAutocomplete-option {
  color: var(--text-primary) !important;
  background: var(--surface) !important;
}
.MuiDrawer-paperAnchorBottom p,
.MuiDrawer-paperAnchorBottom span {
  color: var(--text-primary);
}
/* Fix DialogTitle text inside Drawers */
.MuiDrawer-paperAnchorBottom h2,
.MuiDrawer-paperAnchorBottom .MuiDialogTitle-root {
  color: var(--text-primary) !important;
}

.TypeClass {
  text-transform: capitalize !important;
}
.MuiAutocomplete-input,
.MuiAutocomplete-option,
.MuiInputBase-inputSizeSmall {
  font-size: 12px !important;
}

.bouncing-loader {
  display: flex;
  justify-content: center;
}

.bouncing-loader > div {
  width: 16px;
  height: 16px;
  margin: 3px 6px;
  border-radius: 50%;
  background-color: white;
  opacity: 1;
  animation: bouncing-loader 0.6s infinite alternate;
}

.red-background {
  background-color: red;
}

/* ─── Analysis / Report module shared styles ─── */

/* Cell highlight in analysis grid */
.cellColorAnalysis {
  background-color: var(--brand-primary) !important;
  color: white !important;
}
body.theme-dark .cellColorAnalysis {
  background-color: rgba(56, 189, 248, 0.08) !important;
  border-left: 2px solid var(--brand-primary) !important;
}

/* ─── AG Grid report & analysis heights ─── */
.ag-report-class {
  height: 400px !important;
}
.ag-theme-quartz .ag-checkbox-input-wrapper {
  transform: scale(1.3);
}

/* ─── AG Grid background fix for light theme ─── */
.ag-ltr .ag-cell {
  background: transparent !important;
  color: var(--text-primary) !important;
}
body.theme-dark .ag-ltr .ag-cell {
  color: #E2E8F0 !important;
}
body.theme-light .ag-ltr .ag-cell {
  color: #1E293B !important;
}

/* ─── AG Grid container backgrounds ─── */
body.theme-light .ag-theme-quartz {
  --ag-background-color: #FFFFFF;
  --ag-odd-row-background-color: #F8FAFC;
  --ag-header-background-color: #EFF6FF;
  --ag-border-color: rgba(160, 198, 232, 0.35);
}
body.theme-dark .ag-theme-quartz {
  --ag-background-color: #07101F;
  --ag-odd-row-background-color: #0c1829;
  --ag-header-background-color: #111827;
  --ag-border-color: rgba(148, 163, 184, 0.2);
  --ag-foreground-color: #E2E8F0;
}

/* ─── Analysis Results accordion cards ─── */
.AccordingAnalysis,
.AccordingAnalysis1 {
  background-color: var(--surface) !important;
  border: 1px solid var(--divider) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(8, 96, 211, 0.06) !important;
  transition: box-shadow 0.2s ease, background-color 0.2s ease !important;
}
.AccordingAnalysis:hover,
.AccordingAnalysis1:hover {
  box-shadow: 0 4px 16px rgba(8, 96, 211, 0.12) !important;
}
body.theme-dark .AccordingAnalysis,
body.theme-dark .AccordingAnalysis1 {
  background-color: var(--surface) !important;
  border-color: rgba(56, 189, 248, 0.15) !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.4) !important;
}
body.theme-dark .AccordingAnalysis:hover,
body.theme-dark .AccordingAnalysis1:hover {
  box-shadow: 0 4px 20px rgba(56, 189, 248, 0.2) !important;
}

/* Accordion summary header */
.AccordingAnalysis .MuiAccordionSummary-root,
.AccordingAnalysis1 .MuiAccordionSummary-root {
  border-bottom: 1px solid var(--divider);
  min-height: 42px !important;
  background-color: transparent !important;
}

/* Accordion summary title text */
.AccordingAnalysis .MuiAccordionSummary-content,
.AccordingAnalysis1 .MuiAccordionSummary-content {
  color: var(--brand-primary) !important;
}

/* Expand icon theme color */
.AccordingAnalysis .MuiAccordionSummary-expandIconWrapper,
.AccordingAnalysis1 .MuiAccordionSummary-expandIconWrapper {
  color: var(--brand-primary) !important;
}

/* Accordion details background */
.AccordingAnalysis .MuiAccordionDetails-root,
.AccordingAnalysis1 .MuiAccordionDetails-root {
  background-color: var(--surface) !important;
  color: var(--text-primary) !important;
}

/* ─── Analysis report grid item spacing ─── */
.MuiGrid-root .gridAnalysisItem {
  padding-top: 2px !important;
  padding-left: 5px !important;
}

/* ─── MUI Tab theme support ─── */
body.theme-dark .MuiTab-root {
  color: #94A3B8 !important;
}
body.theme-dark .MuiTab-root.Mui-selected {
  color: var(--brand-primary) !important;
}
body.theme-dark .MuiTabs-indicator {
  background-color: var(--brand-primary) !important;
}
body.theme-dark .MuiTabs-root {
  border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;
}

/* ─── MUI Input theme support ─── */
body.theme-light .MuiInputBase-root,
body.theme-light .MuiOutlinedInput-root {
  color: var(--text-primary);
  background-color: var(--surface);
}
body.theme-light .MuiOutlinedInput-notchedOutline {
  border-color: var(--divider) !important;
}
body.theme-light .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--brand-primary) !important;
}

body.theme-dark .MuiOutlinedInput-root {
  color: var(--text-primary);
  background-color: rgba(255,255,255,0.04);
}
body.theme-dark .MuiOutlinedInput-notchedOutline {
  border-color: var(--divider) !important;
}
body.theme-dark .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--brand-primary) !important;
}

/* ─── MUI Icon Button theme support ─── */
body.theme-light .MuiIconButton-root {
  color: #475569 !important;
}
body.theme-light .MuiIconButton-root:hover {
  color: var(--brand-primary) !important;
  background: rgba(8, 96, 211, 0.08) !important;
}
body.theme-dark .MuiIconButton-root {
  color: #94A3B8 !important;
}
body.theme-dark .MuiIconButton-root:hover {
  color: var(--brand-primary) !important;
  background: rgba(56, 189, 248, 0.1) !important;
}

/* ─── Scrollbar theme support ─── */
body.theme-light ::-webkit-scrollbar-track {
  background: #f1f1f1;
}
body.theme-light ::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 4px;
}
body.theme-dark ::-webkit-scrollbar-track {
  background: #0f172a;
}
body.theme-dark ::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 4px;
}
body.theme-dark ::-webkit-scrollbar-thumb:hover {
  background: #475569;
}

/* ─── Proposed Cycle input dark theme ─── */
body.theme-dark .MuiInput-root input[type="number"] {
  color: var(--text-primary) !important;
}
body.theme-dark .MuiInput-underline:before {
  border-bottom-color: var(--divider) !important;
}

.ag-analysis-grid {
  height: calc(100vh - 348px) !important;
}
.cell-span {
  background-color: #173f00 !important;
}

.speakToTextButton {
  display: flex;
  justify-content: center;
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background: #0555aa;
  transition: all 0.3s ease-in-out 0s;
  box-shadow: rgba(193, 244, 246, 0.698) 0px 0px 0px 0px;
  animation: 1.2s cubic-bezier(0.8, 0, 0, 1) 0s infinite normal none running
    pulse;
  align-items: center;
  border: 0;
  margin-right: 5px;
  cursor: pointer;
}

.speakToTextButton:is(:hover, :focus) {
  transform: scale(1.2);
}

@keyframes pulse {
  100% {
    box-shadow: 0 0 0 45px rgba(193, 244, 246, 0);
  }
}
/* .AccordingAnalysis {
  background-color: #c7d59d !important;
}
.AccordingAnalysis1 {
  background-color: #cfd7b4 !important;
} */

.requiredFieldNull {
  background: white !important;
}
.custom-toast {
  color: red !important; /* Text color */
  background-color: white !important; /* Background color */
  text-transform: capitalize;
  border: 3px solid #0555aa !important;
  width: 600px;
}

.custom-toast .Toastify__progress-bar {
  background: #4caf50 !important; /* Progress bar color */
}

.ag-grid-helpdesk .ag-header-viewport {
  background-color: #0555aa !important;
}

.matchDealerName {
  color: red !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.toastMessageCompanyChange {
  font-weight: 800;
  color: red;
}

/* ─── Tab visibility fixes ─── */
.MuiTab-root {
  color: #475569 !important;
  font-weight: 500 !important;
  opacity: 1 !important;
  transition: color 0.2s ease !important;
}
.MuiTab-root.Mui-selected {
  color: #1D4ED8 !important;
  font-weight: 700 !important;
}
.MuiTabs-indicator {
  background-color: #1D4ED8 !important;
  height: 3px !important;
  border-radius: 3px 3px 0 0 !important;
}
.MuiTabs-root {
  border-bottom: 1px solid rgba(148, 163, 184, 0.35) !important;
}

/* Sidebar inactive icon and text */
.MuiListItemIcon-root {
  color: #64748B !important;
}

/* Edit & Delete action icons in grid */
.MuiIconButton-root {
  color: #94A3B8 !important;
  transition: color 0.2s ease, background 0.2s ease !important;
}
.MuiIconButton-root:hover {
  color: #0860d3 !important;
  background: rgba(56, 189, 248, 0.1) !important;
}

/* Checkbox */
.MuiCheckbox-root {
  color: #64748B !important;
}
.MuiCheckbox-root.Mui-checked {
  color: #0860d3 !important;
}

/* ─── Close icon in dialogs/drawers ─── */
body.theme-light .MuiDialogTitle-root + .MuiIconButton-root {
  color: #475569 !important;
}
body.theme-dark .MuiDialogTitle-root + .MuiIconButton-root {
  color: #94A3B8 !important;
}

/* ─── MUI Divider theme ─── */
body.theme-light .MuiDivider-root {
  border-color: var(--divider) !important;
}
body.theme-dark .MuiDivider-root {
  border-color: rgba(148, 163, 184, 0.2) !important;
}

/* ─── MUI Paper / Card backgrounds ─── */
body.theme-light .MuiPaper-root {
  background-color: var(--surface) !important;
  color: var(--text-primary) !important;
}
body.theme-dark .MuiPaper-root {
  background-color: var(--surface) !important;
  color: var(--text-primary) !important;
}


.ag-simple-filter-body-wrapper{
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
}

.upload-csv-button{
  color: black !important;
}

body.cursor-loading,
body.cursor-loading * {
  cursor: progress !important;
}

/* ─── Premium AG Grid embedded styles (Analysis Report) ─── */
.premium-grid-wrapper {
  /* Wrapper for seamless grid */
}
.ag-analysis-grid.ag-theme-quartz {
  --ag-header-background-color: transparent !important;
  --ag-odd-row-background-color: transparent !important;
  --ag-background-color: transparent !important;
  --ag-border-color: transparent !important;
  --ag-row-border-color: var(--divider) !important;
  --ag-header-foreground-color: var(--text-secondary) !important;
  --ag-font-family: inherit !important;
}
body.theme-light .ag-analysis-grid.ag-theme-quartz {
  --ag-header-foreground-color: #64748b !important;
}
.ag-analysis-grid.ag-theme-quartz .ag-header-cell-label {
  font-weight: 700 !important;
  font-size: 13px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}
.ag-analysis-grid.ag-theme-quartz .ag-cell {
  font-size: 14px !important;
  font-weight: 600 !important;
  display: flex !important;
  align-items: center !important;
}
.ag-analysis-grid.ag-theme-quartz .ag-root-wrapper {
  border: none !important;
  border-radius: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,qCAAqC;EACrC,qCAAqC;AACvC;;;AAGA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,oCAAoC;EACpC,qBAAqB;EACrB,mDAAmD;EACnD,wBAAwB;EACxB,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,iCAAiC;EACjC,qBAAqB;EACrB,wEAAwE;EACxE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,sBAAsB;EACtB,iCAAiC;EACjC,wCAAgC;UAAhC,gCAAgC;EAChC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf;0DACwD;EACxD,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,iCAAiC;EACjC,iEAAyD;UAAzD,yDAAyD;EACzD,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,4BAA4B;EAC5B,mCAA2B;UAA3B,2BAA2B;EAC3B,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EAGjB,aAAa;EAGb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA,uFAAuF;;AAEvF;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;;;;IAKE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,wCAAwC;AAC1C;AACA;;;;;;;;GAQG;AACH;EACE,mBAAmB;AACrB;AACA;;GAEG;;AAEH;EACE,iDAAiD;EACjD,uBAAuB;AACzB;AACA;EACE,mDAAmD;AACrD;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iDAAiD;EACjD,uBAAuB;AACzB;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,wEAAwE;EACxE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,SAAS;EACX;EACA;IACE,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,6BAA6B,EAAE,yBAAyB;AAC1D;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,0DAA0D;AAC5D;AACA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,4EAA4E;AAC9E;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,0BAA0B;EAC1B,4EAA4E;AAC9E;AACA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,0DAA0D;AAC5D;AACA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,8DAA8D;AAChE;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,gDAAgD;EAChD,0DAA0D;EAC1D,uEAAuE;EACvE,iDAAiD;EACjD,yCAAyC;EACzC,gDAAgD;EAChD,sDAAsD;EACtD,2DAA2D;EAC3D,mDAAmD;EACnD,iDAAiD;EACjD,iFAAiF;AACnF;AACA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,gDAAgD;EAChD,yDAAyD;EACzD,uEAAuE;EACvE,mEAAmE;EACnE,yCAAyC;EACzC,gDAAgD;EAChD,uDAAuD;EACvD,2DAA2D;EAC3D,mDAAmD;EACnD,iDAAiD;AACnD;AACA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC;;IAEE,qCAAqC;EACvC;EACA,8CAAsC;UAAtC,sCAAsC;EACtC,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA,mDAAmD;AACnD;;;EAGE,4BAA4B;AAC9B;AACA;EACE,sCAAsC;AACxC;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;AACA;;EAEE,0BAA0B;AAC5B;AACA,wCAAwC;AACxC;;EAEE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;AACA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mDAAmD;;AAEnD,oCAAoC;AACpC;EACE,iDAAiD;EACjD,uBAAuB;AACzB;AACA;EACE,qDAAqD;EACrD,sDAAsD;AACxD;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,qCAAqC;EACrC,4CAA4C;AAC9C;AACA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,qCAAqC;EACrC,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;;EAEE,2CAA2C;EAC3C,2CAA2C;EAC3C,8BAA8B;EAC9B,uDAAuD;EACvD,uEAAuE;AACzE;AACA;;EAEE,wDAAwD;AAC1D;AACA;;EAEE,2CAA2C;EAC3C,iDAAiD;EACjD,oDAAoD;AACtD;AACA;;EAEE,yDAAyD;AAC3D;;AAEA,6BAA6B;AAC7B;;EAEE,uCAAuC;EACvC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;;EAEE,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;;EAEE,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;;EAEE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA,8CAA8C;AAC9C;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,4DAA4D;AAC9D;;AAEA,oCAAoC;AACpC;;EAEE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,6CAA6C;AAC/C;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,qCAAqC;AACvC;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,sDAAsD;EACtD;SACO;EACP,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;AACA;;;;;GAKG;;AAEH;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB,EAAE,eAAe;EACtC,kCAAkC,EAAE,qBAAqB;EACzD,0BAA0B;EAC1B,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,8BAA8B,EAAE,uBAAuB;AACzD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,6DAA6D;AAC/D;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,4DAA4D;AAC9D;AACA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,aAAa;AACb;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,uCAAuC;AACzC;AACA;EACE,iDAAiD;AACnD;;AAEA,yCAAyC;AACzC;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;AACA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;;AAGA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,8BAA8B;AAChC;AACA;EACE,oDAAoD;EACpD,qDAAqD;EACrD,6CAA6C;EAC7C,yCAAyC;EACzC,gDAAgD;EAChD,8DAA8D;EAC9D,oCAAoC;AACtC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B","sourcesContent":[":root {\r\n  --sidebar-width: 200px;\r\n  --brand-primary: #0860D3;\r\n  --brand-primary-hover: #208DE9;\r\n  --brand-secondary: #78C2F8;\r\n  --brand-accent: #A2CDF0;\r\n  --brand-info: #5FA4E7;\r\n  --brand-dark: #1555AB;\r\n  --brand-navy: #0A2360;\r\n  --text-primary: #020617;\r\n  --text-secondary: #9B9FA2;\r\n  --bg-page: #F2F7FB;\r\n  --surface: #FFFFFF;\r\n  --state-success: #16a34a;\r\n  --state-success-hover: #22c55e;\r\n  --state-danger: #dc3545;\r\n  --state-danger-hover: #ef4444;\r\n  --divider: rgba(160, 198, 232, 0.35);\r\n}\r\n\r\nbody.theme-light {\r\n  --bg-page: #F2F7FB;\r\n  --surface: #FFFFFF;\r\n  --text-primary: #020617;\r\n  --text-secondary: #9B9FA2;\r\n  --brand-primary: #0860D3;\r\n  --brand-secondary: #78C2F8;\r\n  --brand-info: #5FA4E7;\r\n  --state-success: #16a34a;\r\n  --state-success-hover: #22c55e;\r\n  --state-danger: #dc3545;\r\n  --state-danger-hover: #ef4444;\r\n  --divider: rgba(160, 198, 232, 0.35);\r\n}\r\n\r\nbody.theme-dark {\r\n  --bg-page: #020617;\r\n  --surface: #07101F;\r\n  --text-primary: #F8FAFC;\r\n  --text-secondary: #94A3B8;\r\n  --brand-primary: #0860d3;\r\n  --brand-secondary: #8B5CF6;\r\n  --brand-info: #7DD3FC;\r\n  --state-success: #22c55e;\r\n  --state-success-hover: #4ade80;\r\n  --state-danger: #ef4444;\r\n  --state-danger-hover: #f87171;\r\n  --divider: rgba(148, 163, 184, 0.25);\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  font-size: 12px !important;\r\n  background: var(--bg-page) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n\r\n.ag-theme-quartz .ag-header {\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\r\n  background-color: transparent !important;\r\n}\r\n\r\n.ag-theme-quartz .ag-header-cell-label {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  color: #64748b;\r\n}\r\n\r\n.fleet-grid-header .ag-header-cell-label {\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n\r\n.ag-theme-quartz .ag-row {\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\r\n}\r\n\r\nbody.theme-dark .ag-theme-quartz .ag-header {\r\n  background-color: transparent !important;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;\r\n}\r\n\r\nbody.theme-dark .ag-theme-quartz .ag-header-cell-label {\r\n  color: #94A3B8 !important;\r\n}\r\n\r\nbody.theme-dark .ag-theme-quartz .ag-cell,\r\nbody.theme-dark .ag-theme-quartz .ag-row {\r\n  color: #E5E7EB !important;\r\n}\r\n\r\nbody.theme-dark .ag-theme-quartz .ag-row {\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;\r\n}\r\n\r\nbody.theme-dark .ag-theme-quartz .ag-row-hover {\r\n  background-color: rgba(255, 255, 255, 0.03) !important;\r\n}\r\n\r\nbody.theme-dark .ag-theme-quartz .ag-row-selected {\r\n  background-color: rgba(255, 255, 255, 0.05) !important;\r\n}\r\n\r\nbody.theme-dark .ag-theme-quartz .ag-header-cell,\r\nbody.theme-dark .ag-theme-quartz .ag-header-cell-text,\r\nbody.theme-dark .ag-theme-quartz .ag-header-viewport {\r\n  color: #94A3B8 !important;\r\n}\r\n\r\nbody.theme-dark .MuiInputLabel-root,\r\nbody.theme-dark .MuiFormLabel-root,\r\nbody.theme-dark .MuiInputBase-input,\r\nbody.theme-dark .MuiOutlinedInput-input,\r\nbody.theme-dark .MuiInputBase-inputSizeSmall,\r\nbody.theme-dark .MuiSelect-select,\r\nbody.theme-dark .MuiInput-input {\r\n  color: #E5E7EB !important;\r\n}\r\n\r\nbody.theme-dark .MuiInputLabel-root.Mui-focused,\r\nbody.theme-dark .MuiFormLabel-root.Mui-focused {\r\n  color: #0860d3 !important;\r\n}\r\n\r\n.scroll {\r\n  top: 0px;\r\n  left: auto;\r\n  color: rgb(123, 128, 154) !important;\r\n  right: 0px !important;\r\n  width: calc(100% - var(--sidebar-width)) !important;\r\n  display: grid !important;\r\n  padding: 0.5rem 0.5rem 0.5rem 1rem;\r\n  z-index: 1100;\r\n  position: relative;\r\n  box-shadow: none !important;\r\n  box-sizing: border-box !important;\r\n  min-height: 4.6875rem;\r\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  margin-left: var(--sidebar-width);\r\n  border-radius: 0.75rem;\r\n  flex-direction: column !important;\r\n  backdrop-filter: none !important;\r\n  background-color: transparent !important;\r\n}\r\n.scroll::after {\r\n  top: 0px !important;\r\n  left: auto !important;\r\n  color: rgb(52, 71, 103) !important;\r\n  right: 0px !important;\r\n  display: grid !important;\r\n  padding: 0.5rem 0.5rem 0.5rem 1rem;\r\n  z-index: 1100;\r\n  position: fixed;\r\n  box-shadow: rgb(255 255 255 / 90%) 0rem 0rem 0.0625rem 0.0625rem inset,\r\n    rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem !important;\r\n  box-sizing: border-box !important;\r\n  margin-top: 10px;\r\n  min-height: 4.6875rem !important;\r\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  margin-right: 6px;\r\n  border-radius: 0.75rem;\r\n  flex-direction: column !important;\r\n  backdrop-filter: saturate(200%) blur(1.875rem) !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.searchInput {\r\n  background-color: rgba(5,85,170,0.5) !important;\r\n  color: white;\r\n  margin-right: 0px !important;\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(56,189,248,0.3) !important;\r\n  border-radius: 8px;\r\n}\r\n\r\n.fxt-template-layout21 {\r\n  min-height: 100vh;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  background-color: #020617;\r\n  color: #f8fafc;\r\n  padding: 15px;\r\n}\r\n\r\n/* Removed hardcoded black overrides for MuiTabs as they are handled in theme-context */\r\n\r\n/* .fxt-template-animation {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 100%;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  -o-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n.fxt-template-layout21 #particles-js {\r\n  position: absolute;\r\n  z-index: -1;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100vw;\r\n  height: 100%;\r\n  opacity: 0.5;\r\n} */\r\n\r\n.css-m3lf6h-MuiButtonBase-root-MuiListItemButton-root.Mui-focusVisible {\r\n  background-color: #0555aa !important;\r\n}\r\n\r\n/* Define keyframes */\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes bounce {\r\n  0%,\r\n  20%,\r\n  50%,\r\n  80%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  40% {\r\n    transform: translateY(-30px);\r\n  }\r\n  60% {\r\n    transform: translateY(-15px);\r\n  }\r\n}\r\n\r\n.super-app-theme--header {\r\n  background-color: var(--brand-primary);\r\n  color: white;\r\n}\r\n\r\n.MuiDataGrid-filler {\r\n  background-color: var(--brand-primary);\r\n}\r\n\r\n.css-tgsonj {\r\n  background-color: white !important;\r\n}\r\n\r\n.evenClassRow {\r\n  background-color: rgba(8, 96, 211, 0.08);\r\n  color: var(--text-primary);\r\n}\r\n.oddClassRow {\r\n  background-color: rgba(8, 96, 211, 0.03);\r\n}\r\n/* .MuiDataGrid-footerContainer{\r\n  background-color: rgb(156, 191, 46);\r\n}\r\n.MuiTablePagination-toolbar{\r\n  color: white !important;\r\n}\r\n.MuiTablePagination-selectIcon,.MuiIconButton-sizeMedium{\r\n  color: white !important;\r\n} */\r\n.MuiDataGrid-cell:focus {\r\n  outline: solid #fff;\r\n}\r\n/* .MuiDataGrid-selectedRowCount{\r\n  color: white;\r\n} */\r\n\r\n.MuiDataGrid-virtualScrollerContent .MuiDataGrid-row.Mui-selected {\r\n  background-color: var(--brand-primary) !important;\r\n  color: white !important;\r\n}\r\n.MuiDataGrid-virtualScrollerContent .MuiDataGrid-row:hover {\r\n  background-color: rgba(8, 96, 211, 0.12) !important;\r\n}\r\n.MuiDataGrid-columnHeader:focus,\r\n.MuiDataGrid-cell:focus {\r\n  outline: none !important;\r\n}\r\n.MuiDataGrid-scrollbarFiller {\r\n  display: none;\r\n}\r\n.MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-menuIconButton {\r\n  color: white !important;\r\n}\r\n.MuiDataGrid-columnHeaderTitleContainer {\r\n  background: var(--brand-primary) !important;\r\n  font-size: 13px !important;\r\n}\r\n.dataGridContant {\r\n  font-size: 12px !important;\r\n}\r\n.css-1essi2g-MuiDataGrid-columnHeaderRow {\r\n  background-color: var(--brand-primary) !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Truck Loader */\r\n\r\nbody {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  background-color: transparent;\r\n}\r\n\r\n.loader-wrapper {\r\n  position: fixed;\r\n  z-index: 1090;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  background-color: rgba(13, 27, 62, 0.5) !important;\r\n}\r\n\r\n.loader-box {\r\n  position: absolute;\r\n  top: 30%;\r\n  left: 40%;\r\n  height: 200px;\r\n  width: 200px;\r\n}\r\n\r\n.dot-spinner {\r\n  --uib-size: 2.8rem;\r\n  --uib-speed: 0.9s;\r\n  --uib-color: #183153;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  height: var(--uib-size);\r\n  width: var(--uib-size);\r\n}\r\n\r\n.dot-spinner__dot {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.dot-spinner__dot::before {\r\n  content: \"\";\r\n  height: 20%;\r\n  width: 20%;\r\n  border-radius: 50%;\r\n  background-color: var(--uib-color);\r\n  transform: scale(0);\r\n  opacity: 0.5;\r\n  animation: pulse0112 calc(var(--uib-speed) * 1.111) ease-in-out infinite;\r\n  box-shadow: 0 0 20px rgba(18, 31, 53, 0.3);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(2) {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(2)::before {\r\n  animation-delay: calc(var(--uib-speed) * -0.875);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(3) {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(3)::before {\r\n  animation-delay: calc(var(--uib-speed) * -0.75);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(4) {\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(4)::before {\r\n  animation-delay: calc(var(--uib-speed) * -0.625);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(5) {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(5)::before {\r\n  animation-delay: calc(var(--uib-speed) * -0.5);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(6) {\r\n  transform: rotate(225deg);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(6)::before {\r\n  animation-delay: calc(var(--uib-speed) * -0.375);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(7) {\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(7)::before {\r\n  animation-delay: calc(var(--uib-speed) * -0.25);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(8) {\r\n  transform: rotate(315deg);\r\n}\r\n\r\n.dot-spinner__dot:nth-child(8)::before {\r\n  animation-delay: calc(var(--uib-speed) * -0.125);\r\n}\r\n\r\n@keyframes pulse0112 {\r\n  0%,\r\n  100% {\r\n    transform: scale(0);\r\n    opacity: 0.5;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fade {\r\n  30% {\r\n    opacity: 0.3;\r\n    left: 7px;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n    left: 6px;\r\n  }\r\n\r\n  70% {\r\n    opacity: 0.1;\r\n    left: 4px;\r\n  }\r\n\r\n  90% {\r\n    opacity: 0.4;\r\n    left: 2px;\r\n  }\r\n}\r\n\r\n@keyframes bg {\r\n  from {\r\n    background-position-x: 0px;\r\n  }\r\n  to {\r\n    background-position-x: -400px;\r\n  }\r\n}\r\n\r\n@keyframes updown {\r\n  50% {\r\n    transform: translateY(-20%);\r\n  }\r\n\r\n  70% {\r\n    transform: translateY(-10%);\r\n  }\r\n}\r\n\r\n@keyframes updown-half {\r\n  50% {\r\n    transform: translateY(-10%);\r\n  }\r\n\r\n  70% {\r\n    transform: translateY(-5%);\r\n  }\r\n}\r\n\r\n.Mui-checked {\r\n  color: white !important;\r\n}\r\n\r\n.css-19kzrtu {\r\n  padding: 0px !important;\r\n}\r\nspan {\r\n  font-size: 12px !important;\r\n}\r\n.MuiDataGrid-sortIcon,\r\n.MuiDataGrid-menuIconButton {\r\n  color: #ffff !important;\r\n  font-weight: 600;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 7px;\r\n  height: 8px;\r\n}\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: #0555aa;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n.MuiButtonBase-root {\r\n  font-size: 12px !important;\r\n}\r\n.MuiDataGrid-cell {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.MuiTablePagination-menuItem {\r\n  top: calc(100% - 180px) !important;\r\n}\r\n#star {\r\n  animation: rotateStar 1s linear infinite;\r\n  transform-origin: 325px 305px; /* Center of the circle */\r\n}\r\n\r\n@keyframes rotateStar {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n.ag-paging-panel {\r\n  background: rgba(248, 250, 252, 0.95) !important;\r\n  color: #0f172a !important;\r\n  border-top: 1px solid rgba(148, 163, 184, 0.35) !important;\r\n}\r\n.ag-paging-panel .ag-input-field-input,\r\n.ag-paging-panel .ag-select,\r\n.ag-paging-panel .ag-paging-button {\r\n  background: #ffffff !important;\r\n  color: #0f172a !important;\r\n  border-color: rgba(148, 163, 184, 0.3) !important;\r\n}\r\n.ag-paging-panel .ag-paging-button:hover {\r\n  background: rgba(29, 78, 216, 0.08) !important;\r\n}\r\n.ag-wrapper {\r\n  color: #0f172a !important;\r\n}\r\n.ag-header {\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.35) !important;\r\n}\r\n.ag-header-row-column {\r\n  background: transparent !important;\r\n  color: #1D4ED8 !important;\r\n  font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;\r\n}\r\n.ag-icon {\r\n  color: #1D4ED8 !important;\r\n}\r\n.ag-row {\r\n  background-color: transparent !important;\r\n  color: #020617 !important;\r\n  font-size: 12px !important;\r\n  font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;\r\n}\r\n.ag-row-selected {\r\n  background: rgba(59, 130, 246, 0.12) !important;\r\n  color: #0f172a !important;\r\n}\r\n.ag-row-hover {\r\n  background: rgba(191, 219, 254, 0.6) !important;\r\n  color: #0f172a !important;\r\n  opacity: 1 !important;\r\n}\r\n.highlight-red {\r\n  color: red;\r\n}\r\nbody.theme-dark .ag-paging-panel {\r\n  background: rgba(15, 23, 42, 0.95) !important;\r\n  color: #E5E7EB !important;\r\n  border-top: 1px solid rgba(100, 116, 139, 0.25) !important;\r\n}\r\nbody.theme-dark .ag-paging-panel .ag-input-field-input,\r\nbody.theme-dark .ag-paging-panel .ag-select,\r\nbody.theme-dark .ag-paging-panel .ag-paging-button {\r\n  background: #111827 !important;\r\n  color: #E5E7EB !important;\r\n  border-color: rgba(100, 116, 139, 0.4) !important;\r\n}\r\nbody.theme-dark .ag-paging-panel .ag-paging-button:hover {\r\n  background: rgba(59, 130, 246, 0.12) !important;\r\n}\r\nbody.theme-dark .ag-wrapper {\r\n  color: #E5E7EB !important;\r\n}\r\nbody.theme-dark .ag-header {\r\n  border-bottom: 1px solid rgba(100, 116, 139, 0.35) !important;\r\n}\r\nbody.theme-dark .ag-header-row-column {\r\n  background: transparent !important;\r\n  color: #93C5FD !important;\r\n}\r\nbody.theme-dark .ag-icon {\r\n  color: #93C5FD !important;\r\n}\r\nbody.theme-dark .ag-row {\r\n  background-color: transparent !important;\r\n  color: #E5E7EB !important;\r\n}\r\nbody.theme-dark .ag-row-selected {\r\n  background: rgba(59, 130, 246, 0.18) !important;\r\n  color: #E5E7EB !important;\r\n}\r\nbody.theme-dark .ag-row-hover {\r\n  background: rgba(59, 130, 246, 0.18) !important;\r\n  color: #E5E7EB !important;\r\n  opacity: 1 !important;\r\n}\r\n.ag-row-hover .highlight-red {\r\n  background: red !important;\r\n  color: white !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.ag-row-selected .muiSeletc,\r\n.ag-row-hover .muiSeletc,\r\n.ag-row-selected .muiSeletc svg,\r\n.ag-row-hover .muiSeletc svg {\r\n  color: #0f172a !important;\r\n  opacity: 1 !important;\r\n}\r\n.SelectedModelClass .MuiSelect-select,\r\n.Mui-focused {\r\n  background-color: transparent !important;\r\n  border: none;\r\n}\r\n.ag-row-selected .SelectedModelClass .MuiInputBase-root::after {\r\n  border-bottom: 1px solid #1D4ED8 !important;\r\n}\r\n.ag-row-selected .SelectedModelClass .MuiInputBase-root::before {\r\n  border-bottom: 1px solid #1D4ED8 !important;\r\n}\r\n.SelectedModelClass .MuiInputBase-root::after {\r\n  border-bottom: 1px solid rgba(29, 78, 216, 0.4) !important;\r\n}\r\n.SelectedModelClass .MuiInputBase-root::before {\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.407) !important;\r\n}\r\n.css-q46f9q-MuiInputBase-root-MuiInput-root {\r\n  font-size: 12px !important;\r\n}\r\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\r\n  padding: 10px !important;\r\n  font-size: 12px !important;\r\n}\r\n.ag-checkbox-input-wrapper.ag-checked::after {\r\n  color: #0860d3 !important;\r\n}\r\n\r\n.ag-theme-quartz {\r\n  --ag-active-color: #1D4ED8 !important;\r\n  --ag-background-color: #FFFFFF !important;\r\n  --ag-header-background-color: #FFFFFF !important;\r\n  --ag-row-hover-color: rgba(191, 219, 254, 0.55) !important;\r\n  --ag-selected-row-background-color: rgba(59, 130, 246, 0.14) !important;\r\n  --ag-odd-row-background-color: #F8FAFC !important;\r\n  --ag-foreground-color: #0F172A !important;\r\n  --ag-header-foreground-color: #1D4ED8 !important;\r\n  --ag-border-color: rgba(148, 163, 184, 0.3) !important;\r\n  --ag-row-border-color: rgba(148, 163, 184, 0.18) !important;\r\n  --ag-secondary-foreground-color: #64748B !important;\r\n  --ag-input-focus-border-color: #1D4ED8 !important;\r\n  --ag-font-family: 'Outfit', 'Inter', 'Roboto', 'Helvetica', sans-serif !important;\r\n}\r\nbody.theme-dark .ag-theme-quartz {\r\n  --ag-active-color: #60A5FA !important;\r\n  --ag-background-color: #111827 !important;\r\n  --ag-header-background-color: #1F2937 !important;\r\n  --ag-row-hover-color: rgba(59, 130, 246, 0.18) !important;\r\n  --ag-selected-row-background-color: rgba(59, 130, 246, 0.18) !important;\r\n  --ag-odd-row-background-color: rgba(255, 255, 255, 0.04) !important;\r\n  --ag-foreground-color: #E5E7EB !important;\r\n  --ag-header-foreground-color: #93C5FD !important;\r\n  --ag-border-color: rgba(148, 163, 184, 0.15) !important;\r\n  --ag-row-border-color: rgba(148, 163, 184, 0.08) !important;\r\n  --ag-secondary-foreground-color: #94A3B8 !important;\r\n  --ag-input-focus-border-color: #60A5FA !important;\r\n}\r\n.MuiDialog-paperScrollPaper,\r\n.MuiDialog-paperScrollPaper form {\r\n  width: 100% !important;\r\n}\r\n\r\n.DrawerName {\r\n  bottom: 56px !important;\r\n  top: 80px !important;\r\n}\r\n\r\n/* ─── Adaptive glassmorphism for all Drawer popups ─── */\r\n.MuiDrawer-paperAnchorBottom {\r\n  bottom: 56px !important;\r\n  top: 80px !important;\r\n  background: var(--surface) !important;\r\n  body.theme-dark .ag-theme-quartz .ag-root-wrapper,\r\n  body.theme-dark .ag-theme-quartz .ag-header {\r\n    background: var(--surface) !important;\r\n  }\r\n  backdrop-filter: blur(40px) !important;\r\n  border-top: 1px solid var(--divider) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n/* Fix all labels, text and inputs inside drawers */\r\n.MuiDrawer-paperAnchorBottom label,\r\n.MuiDrawer-paperAnchorBottom .MuiInputLabel-root,\r\n.MuiDrawer-paperAnchorBottom .MuiFormLabel-root {\r\n  color: var(--text-secondary);\r\n}\r\n.MuiDrawer-paperAnchorBottom .MuiInputLabel-root.Mui-focused {\r\n  color: var(--brand-primary) !important;\r\n}\r\n.MuiDrawer-paperAnchorBottom .MuiSelect-select,\r\n.MuiDrawer-paperAnchorBottom .MuiInputBase-input,\r\n.MuiDrawer-paperAnchorBottom .MuiInput-input {\r\n  color: var(--text-primary) !important;\r\n}\r\n.MuiDrawer-paperAnchorBottom .MuiInput-underline::before {\r\n  border-bottom-color: var(--divider) !important;\r\n}\r\n.MuiDrawer-paperAnchorBottom .MuiInput-underline::after {\r\n  border-bottom-color: var(--brand-primary) !important;\r\n}\r\n.MuiDrawer-paperAnchorBottom .MuiSvgIcon-root {\r\n  color: var(--text-secondary) !important;\r\n}\r\n.MuiDrawer-paperAnchorBottom .MuiAutocomplete-option {\r\n  color: var(--text-primary) !important;\r\n  background: var(--surface) !important;\r\n}\r\n.MuiDrawer-paperAnchorBottom p,\r\n.MuiDrawer-paperAnchorBottom span {\r\n  color: var(--text-primary);\r\n}\r\n/* Fix DialogTitle text inside Drawers */\r\n.MuiDrawer-paperAnchorBottom h2,\r\n.MuiDrawer-paperAnchorBottom .MuiDialogTitle-root {\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n.TypeClass {\r\n  text-transform: capitalize !important;\r\n}\r\n.MuiAutocomplete-input,\r\n.MuiAutocomplete-option,\r\n.MuiInputBase-inputSizeSmall {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.bouncing-loader {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.bouncing-loader > div {\r\n  width: 16px;\r\n  height: 16px;\r\n  margin: 3px 6px;\r\n  border-radius: 50%;\r\n  background-color: white;\r\n  opacity: 1;\r\n  animation: bouncing-loader 0.6s infinite alternate;\r\n}\r\n\r\n.red-background {\r\n  background-color: red;\r\n}\r\n\r\n/* ─── Analysis / Report module shared styles ─── */\r\n\r\n/* Cell highlight in analysis grid */\r\n.cellColorAnalysis {\r\n  background-color: var(--brand-primary) !important;\r\n  color: white !important;\r\n}\r\nbody.theme-dark .cellColorAnalysis {\r\n  background-color: rgba(56, 189, 248, 0.08) !important;\r\n  border-left: 2px solid var(--brand-primary) !important;\r\n}\r\n\r\n/* ─── AG Grid report & analysis heights ─── */\r\n.ag-report-class {\r\n  height: 400px !important;\r\n}\r\n.ag-theme-quartz .ag-checkbox-input-wrapper {\r\n  transform: scale(1.3);\r\n}\r\n\r\n/* ─── AG Grid background fix for light theme ─── */\r\n.ag-ltr .ag-cell {\r\n  background: transparent !important;\r\n  color: var(--text-primary) !important;\r\n}\r\nbody.theme-dark .ag-ltr .ag-cell {\r\n  color: #E2E8F0 !important;\r\n}\r\nbody.theme-light .ag-ltr .ag-cell {\r\n  color: #1E293B !important;\r\n}\r\n\r\n/* ─── AG Grid container backgrounds ─── */\r\nbody.theme-light .ag-theme-quartz {\r\n  --ag-background-color: #FFFFFF;\r\n  --ag-odd-row-background-color: #F8FAFC;\r\n  --ag-header-background-color: #EFF6FF;\r\n  --ag-border-color: rgba(160, 198, 232, 0.35);\r\n}\r\nbody.theme-dark .ag-theme-quartz {\r\n  --ag-background-color: #07101F;\r\n  --ag-odd-row-background-color: #0c1829;\r\n  --ag-header-background-color: #111827;\r\n  --ag-border-color: rgba(148, 163, 184, 0.2);\r\n  --ag-foreground-color: #E2E8F0;\r\n}\r\n\r\n/* ─── Analysis Results accordion cards ─── */\r\n.AccordingAnalysis,\r\n.AccordingAnalysis1 {\r\n  background-color: var(--surface) !important;\r\n  border: 1px solid var(--divider) !important;\r\n  border-radius: 12px !important;\r\n  box-shadow: 0 2px 8px rgba(8, 96, 211, 0.06) !important;\r\n  transition: box-shadow 0.2s ease, background-color 0.2s ease !important;\r\n}\r\n.AccordingAnalysis:hover,\r\n.AccordingAnalysis1:hover {\r\n  box-shadow: 0 4px 16px rgba(8, 96, 211, 0.12) !important;\r\n}\r\nbody.theme-dark .AccordingAnalysis,\r\nbody.theme-dark .AccordingAnalysis1 {\r\n  background-color: var(--surface) !important;\r\n  border-color: rgba(56, 189, 248, 0.15) !important;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.4) !important;\r\n}\r\nbody.theme-dark .AccordingAnalysis:hover,\r\nbody.theme-dark .AccordingAnalysis1:hover {\r\n  box-shadow: 0 4px 20px rgba(56, 189, 248, 0.2) !important;\r\n}\r\n\r\n/* Accordion summary header */\r\n.AccordingAnalysis .MuiAccordionSummary-root,\r\n.AccordingAnalysis1 .MuiAccordionSummary-root {\r\n  border-bottom: 1px solid var(--divider);\r\n  min-height: 42px !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n/* Accordion summary title text */\r\n.AccordingAnalysis .MuiAccordionSummary-content,\r\n.AccordingAnalysis1 .MuiAccordionSummary-content {\r\n  color: var(--brand-primary) !important;\r\n}\r\n\r\n/* Expand icon theme color */\r\n.AccordingAnalysis .MuiAccordionSummary-expandIconWrapper,\r\n.AccordingAnalysis1 .MuiAccordionSummary-expandIconWrapper {\r\n  color: var(--brand-primary) !important;\r\n}\r\n\r\n/* Accordion details background */\r\n.AccordingAnalysis .MuiAccordionDetails-root,\r\n.AccordingAnalysis1 .MuiAccordionDetails-root {\r\n  background-color: var(--surface) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n/* ─── Analysis report grid item spacing ─── */\r\n.MuiGrid-root .gridAnalysisItem {\r\n  padding-top: 2px !important;\r\n  padding-left: 5px !important;\r\n}\r\n\r\n/* ─── MUI Tab theme support ─── */\r\nbody.theme-dark .MuiTab-root {\r\n  color: #94A3B8 !important;\r\n}\r\nbody.theme-dark .MuiTab-root.Mui-selected {\r\n  color: var(--brand-primary) !important;\r\n}\r\nbody.theme-dark .MuiTabs-indicator {\r\n  background-color: var(--brand-primary) !important;\r\n}\r\nbody.theme-dark .MuiTabs-root {\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;\r\n}\r\n\r\n/* ─── MUI Input theme support ─── */\r\nbody.theme-light .MuiInputBase-root,\r\nbody.theme-light .MuiOutlinedInput-root {\r\n  color: var(--text-primary);\r\n  background-color: var(--surface);\r\n}\r\nbody.theme-light .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--divider) !important;\r\n}\r\nbody.theme-light .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--brand-primary) !important;\r\n}\r\n\r\nbody.theme-dark .MuiOutlinedInput-root {\r\n  color: var(--text-primary);\r\n  background-color: rgba(255,255,255,0.04);\r\n}\r\nbody.theme-dark .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--divider) !important;\r\n}\r\nbody.theme-dark .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--brand-primary) !important;\r\n}\r\n\r\n/* ─── MUI Icon Button theme support ─── */\r\nbody.theme-light .MuiIconButton-root {\r\n  color: #475569 !important;\r\n}\r\nbody.theme-light .MuiIconButton-root:hover {\r\n  color: var(--brand-primary) !important;\r\n  background: rgba(8, 96, 211, 0.08) !important;\r\n}\r\nbody.theme-dark .MuiIconButton-root {\r\n  color: #94A3B8 !important;\r\n}\r\nbody.theme-dark .MuiIconButton-root:hover {\r\n  color: var(--brand-primary) !important;\r\n  background: rgba(56, 189, 248, 0.1) !important;\r\n}\r\n\r\n/* ─── Scrollbar theme support ─── */\r\nbody.theme-light ::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\nbody.theme-light ::-webkit-scrollbar-thumb {\r\n  background: #94a3b8;\r\n  border-radius: 4px;\r\n}\r\nbody.theme-dark ::-webkit-scrollbar-track {\r\n  background: #0f172a;\r\n}\r\nbody.theme-dark ::-webkit-scrollbar-thumb {\r\n  background: #334155;\r\n  border-radius: 4px;\r\n}\r\nbody.theme-dark ::-webkit-scrollbar-thumb:hover {\r\n  background: #475569;\r\n}\r\n\r\n/* ─── Proposed Cycle input dark theme ─── */\r\nbody.theme-dark .MuiInput-root input[type=\"number\"] {\r\n  color: var(--text-primary) !important;\r\n}\r\nbody.theme-dark .MuiInput-underline:before {\r\n  border-bottom-color: var(--divider) !important;\r\n}\r\n\r\n.ag-analysis-grid {\r\n  height: calc(100vh - 348px) !important;\r\n}\r\n.cell-span {\r\n  background-color: #173f00 !important;\r\n}\r\n\r\n.speakToTextButton {\r\n  display: flex;\r\n  justify-content: center;\r\n  color: #fff;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 100%;\r\n  background: #0555aa;\r\n  transition: all 0.3s ease-in-out 0s;\r\n  box-shadow: rgba(193, 244, 246, 0.698) 0px 0px 0px 0px;\r\n  animation: 1.2s cubic-bezier(0.8, 0, 0, 1) 0s infinite normal none running\r\n    pulse;\r\n  align-items: center;\r\n  border: 0;\r\n  margin-right: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.speakToTextButton:is(:hover, :focus) {\r\n  transform: scale(1.2);\r\n}\r\n\r\n@keyframes pulse {\r\n  100% {\r\n    box-shadow: 0 0 0 45px rgba(193, 244, 246, 0);\r\n  }\r\n}\r\n/* .AccordingAnalysis {\r\n  background-color: #c7d59d !important;\r\n}\r\n.AccordingAnalysis1 {\r\n  background-color: #cfd7b4 !important;\r\n} */\r\n\r\n.requiredFieldNull {\r\n  background: white !important;\r\n}\r\n.custom-toast {\r\n  color: red !important; /* Text color */\r\n  background-color: white !important; /* Background color */\r\n  text-transform: capitalize;\r\n  border: 3px solid #0555aa !important;\r\n  width: 600px;\r\n}\r\n\r\n.custom-toast .Toastify__progress-bar {\r\n  background: #4caf50 !important; /* Progress bar color */\r\n}\r\n\r\n.ag-grid-helpdesk .ag-header-viewport {\r\n  background-color: #0555aa !important;\r\n}\r\n\r\n.matchDealerName {\r\n  color: red !important;\r\n}\r\n\r\n.font-size-16 {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.toastMessageCompanyChange {\r\n  font-weight: 800;\r\n  color: red;\r\n}\r\n\r\n/* ─── Tab visibility fixes ─── */\r\n.MuiTab-root {\r\n  color: #475569 !important;\r\n  font-weight: 500 !important;\r\n  opacity: 1 !important;\r\n  transition: color 0.2s ease !important;\r\n}\r\n.MuiTab-root.Mui-selected {\r\n  color: #1D4ED8 !important;\r\n  font-weight: 700 !important;\r\n}\r\n.MuiTabs-indicator {\r\n  background-color: #1D4ED8 !important;\r\n  height: 3px !important;\r\n  border-radius: 3px 3px 0 0 !important;\r\n}\r\n.MuiTabs-root {\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.35) !important;\r\n}\r\n\r\n/* Sidebar inactive icon and text */\r\n.MuiListItemIcon-root {\r\n  color: #64748B !important;\r\n}\r\n\r\n/* Edit & Delete action icons in grid */\r\n.MuiIconButton-root {\r\n  color: #94A3B8 !important;\r\n  transition: color 0.2s ease, background 0.2s ease !important;\r\n}\r\n.MuiIconButton-root:hover {\r\n  color: #0860d3 !important;\r\n  background: rgba(56, 189, 248, 0.1) !important;\r\n}\r\n\r\n/* Checkbox */\r\n.MuiCheckbox-root {\r\n  color: #64748B !important;\r\n}\r\n.MuiCheckbox-root.Mui-checked {\r\n  color: #0860d3 !important;\r\n}\r\n\r\n/* ─── Close icon in dialogs/drawers ─── */\r\nbody.theme-light .MuiDialogTitle-root + .MuiIconButton-root {\r\n  color: #475569 !important;\r\n}\r\nbody.theme-dark .MuiDialogTitle-root + .MuiIconButton-root {\r\n  color: #94A3B8 !important;\r\n}\r\n\r\n/* ─── MUI Divider theme ─── */\r\nbody.theme-light .MuiDivider-root {\r\n  border-color: var(--divider) !important;\r\n}\r\nbody.theme-dark .MuiDivider-root {\r\n  border-color: rgba(148, 163, 184, 0.2) !important;\r\n}\r\n\r\n/* ─── MUI Paper / Card backgrounds ─── */\r\nbody.theme-light .MuiPaper-root {\r\n  background-color: var(--surface) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\nbody.theme-dark .MuiPaper-root {\r\n  background-color: var(--surface) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n\r\n.ag-simple-filter-body-wrapper{\r\n  backdrop-filter: blur(20px);\r\n}\r\n\r\n.upload-csv-button{\r\n  color: black !important;\r\n}\r\n\r\nbody.cursor-loading,\r\nbody.cursor-loading * {\r\n  cursor: progress !important;\r\n}\r\n\r\n/* ─── Premium AG Grid embedded styles (Analysis Report) ─── */\r\n.premium-grid-wrapper {\r\n  /* Wrapper for seamless grid */\r\n}\r\n.ag-analysis-grid.ag-theme-quartz {\r\n  --ag-header-background-color: transparent !important;\r\n  --ag-odd-row-background-color: transparent !important;\r\n  --ag-background-color: transparent !important;\r\n  --ag-border-color: transparent !important;\r\n  --ag-row-border-color: var(--divider) !important;\r\n  --ag-header-foreground-color: var(--text-secondary) !important;\r\n  --ag-font-family: inherit !important;\r\n}\r\nbody.theme-light .ag-analysis-grid.ag-theme-quartz {\r\n  --ag-header-foreground-color: #64748b !important;\r\n}\r\n.ag-analysis-grid.ag-theme-quartz .ag-header-cell-label {\r\n  font-weight: 700 !important;\r\n  font-size: 13px !important;\r\n  text-transform: uppercase !important;\r\n  letter-spacing: 0.5px !important;\r\n}\r\n.ag-analysis-grid.ag-theme-quartz .ag-cell {\r\n  font-size: 14px !important;\r\n  font-weight: 600 !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n}\r\n.ag-analysis-grid.ag-theme-quartz .ag-root-wrapper {\r\n  border: none !important;\r\n  border-radius: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
